import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators } from '@angular/forms';
import { jsonParse } from 'src/app/app.component';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';


@Component({
  selector: 'app-availability',
  templateUrl: './availability.component.html',
  styleUrls: ['./availability.component.scss']
})
export class AvailabilityComponent implements OnInit {

  @Input() form_control;
  @Input() field_name;
  @Input() data;
  @Input() readonly;
  @Input() masters;
  @Input() required;


  form_group: UntypedFormGroup;
  time_from = [];
  time_to = [];
  readOnlyToggle = [];

  constructor(private fb: UntypedFormBuilder,
    private notification_svc: NotificationService) {
    this.form_group = this.fb.group({})
    // this.form_group = this.fb.group({
    //   field_name: this.fb.array([])
    // })
  }
  days = [{
    title: 'Monday',
    code: '1'
  },
  {
    title: 'Tuesday',
    code: '2'
  },
  {
    title: 'Wednesday',
    code: '3'
  },
  {
    title: 'Thursday',
    code: '4'
  },
  {
    title: 'Friday',
    code: '5'
  },
  {
    title: 'Saturday',
    code: '6'
  },
  {
    title: 'Sunday',
    code: '7'
  }]

  types = [
    {
      title: 'Not Available',
      code: '1'
    },
    {
      title: 'Anytime',
      code: '2'
    },
    {
      title: 'Specific Hours',
      code: '3'
    }]

  ngOnInit(): void {
    if (!this.masters) {
      this.masters = this.days;
    }
    this.form_group.addControl(this.field_name, this.fb.array([]));
    this.addItem()
  }

  ngOnChanges(ev): void {

  }

  createArray(i) {
    return this.fb.group({
      day: [i, Validators.required],
      is_availability: ['', Validators.required],
      specific_time: this.fb.group({
        from: [],
        to: []
      }),
    })
  }

  get getArray() {
    return this.form_group.get([this.field_name]) as UntypedFormArray;
  }

  ngAfterViewInit(): void {

    let obj = this.form_control.value || [];
    this.getArray.patchValue(obj)
    let to = {
      hour: null,
      minute: null,
    };
    let from = {
      hour: null,
      minute: null,
    };;
    for (let i = 0; i < obj.length; i++) {
      obj[i].specific_time = jsonParse(obj[i].specific_time);
      if (obj[i] && obj[i].specific_time && (obj[i].specific_time.from || obj[i].specific_time.from == 0)) {
        from.hour = parseInt((obj[i].specific_time.from).split(':')[0])
        from.minute = parseInt((obj[i].specific_time.from).split(':')[1])
        this.time_from[i] = from;
      }
      if (obj[i] && obj[i].specific_time && (obj[i].specific_time.to || obj[i].specific_time.to == 0)) {
        // this.time_to[i] = obj[i].value.to;
        to.hour = parseInt((obj[i].specific_time.to).split(':')[0])
        to.minute = parseInt((obj[i].specific_time.to).split(':')[1])
        this.time_to[i] = to;
      }


      // this.readOnlyToggle[i] = true;
    }

  }

  addItem() {
    for (let i = 0; i < this.days.length; i++) {
      const element = this.days[i];
      this.getArray.push(this.createArray(element.code))
    }
  }

  setType(i, value) {
    this.getArray.controls[i].get('is_availability').patchValue(value);
    if (value == 3) {
      this.readOnlyToggle[i] = false;
    }
    else {
      this.getArray.controls[i].get('specific_time').get('from').setValue(null);
      this.getArray.controls[i].get('specific_time').get('to').setValue(null);
      this.readOnlyToggle[i] = false
    }
    // if (this.validationCheck()) {
    this.form_control.setValue(this.getArray.value)
    // }


    this.form_control.setValue(this.getArray.value)

  }

  makeReadOnly(i) {
    if (this.time_to[i] && this.time_to[i].hour >= 0 && this.time_to[i].minute >= 0 && this.time_from[i] && this.time_from[i].hour >= 0 && this.time_from[i].minute >= 0) {
      this.readOnlyToggle[i] = this.readOnlyToggle[i] ? false : true;

      this.getArray.controls[i].get('specific_time').get('from').setValue((this.time_from[i].hour + ':' + this.time_from[i].minute));
      this.getArray.controls[i].get('specific_time').get('to').setValue((this.time_to[i].hour + ':' + this.time_to[i].minute));
    }
    else {
      this.notification_svc.snackbar('Please enter correct values', 'Close', 5000)
    }
    // if (this.validationCheck()) {
    this.form_control.setValue(this.getArray.value)
    // }
  }

  change(ev, i) {
    if (this.time_to[i] && this.time_to[i].hour >= 0 && this.time_to[i].minute >= 0 && this.time_from[i] && this.time_from[i].hour >= 0 && this.time_from[i].minute >= 0) {
      this.getArray.controls[i].get('specific_time').get('from').setValue((this.time_from[i].hour + ':' + this.time_from[i].minute));
      this.getArray.controls[i].get('specific_time').get('to').setValue((this.time_to[i].hour + ':' + this.time_to[i].minute));
    }

  }

  validationCheck() {
    let valid_flag = false;
    if (this.getArray.valid && this.readOnlyToggle.reduce((a, b) => a && b)) {
      valid_flag = true;
    }
    return valid_flag
  }
}
